import { jsx as _jsx } from "react/jsx-runtime";
import { RemovableCard, Text } from '@dixa/lib-shared-habla';
import { useEffectOnce } from 'react-use';
import { conversationsBulkModalActionLabel } from '../../../utils/conversationsBulkModalActionLabel';
/** Represents the component for the conversations bulk modal cancel CSAT action. */
export const ConversationsBulkModalCancelCsatAction = ({ conversationIds, onRemove, onChange, }) => {
    useEffectOnce(() => {
        onChange({
            type: 'cancel_csat',
            isValid: true,
            arg: { csids: conversationIds },
        });
    });
    return (_jsx(RemovableCard, Object.assign({ icon: "close", title: conversationsBulkModalActionLabel['cancel_csat'], onRemove: () => onRemove('cancel_csat') }, { children: _jsx(Text.Paragraph, Object.assign({ subdued: true }, { children: "Please note that, once CSAT has been cancelled it cannot be reinstated. Please select this option only if you are sure you would like to cancel CSAT for the selected conversations. If selected conversations are not eligible for CSAT, they will not be affected." })) })));
};
